import { Container } from "semantic-ui-react";

export const DtsManagerHome = () => {

  return (
    <Container>
      DtsManager home
    </Container>
  )
};